module.exports = __webpack_public_path__ + "5d4aeb4e5f5ef754e307d7ffaef688bd.woff2";